import { IAppState } from '../../redux';
import { selectIsNewOffer } from '../offer';
import { selectIsPublishToHiddenBase } from '../publishAvailable';
import { selectIsSubagentLimitExceed } from '../publishTerms';

export function selectPublicationButtonText(state: IAppState): string {
  const isSubagentLimitExceed = selectIsSubagentLimitExceed(state);

  if (isSubagentLimitExceed) {
    return 'Переключиться на личный счёт';
  }

  const { submitText } = state.checkoutInfo;
  const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);
  const isNewOffer = selectIsNewOffer(state);

  const submitTextFallback = isNewOffer ? 'Разместить' : 'Сохранить изменения';

  return (
    (!isPublishToHiddenBase &&
      // В обычной ситуации берём текст для кнопки из check-service
      submitText) ||
    // В случаях, когда check-service не вызывается (публикация в скрытую базу,
    // флоу Сделки в аренде или просто поле не имеет значения), возвращаем фолбэк
    submitTextFallback
  );
}
